(() => {
  const SWITCH_DELAY = 90;

  const initialiseMenu = (menu) => {
    if (menu.dataset.sparkHoverReady === 'true') return;
    menu.dataset.sparkHoverReady = 'true';

    const categories = Array.from(menu.querySelectorAll('.spark-mega__category:not(.spark-mega__category--direct)'));
    if (!categories.length) return;

    const defaultCategory = categories.find((category) => category.classList.contains('is-default')) || categories[0];
    let activeCategory = defaultCategory;
    let switchTimer;

    const activate = (category) => {
      categories.forEach((item) => item.classList.toggle('is-active', item === category));
      activeCategory = category;
    };

    activate(defaultCategory);

    categories.forEach((category) => {
      category.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'touch' || category === activeCategory) return;
        window.clearTimeout(switchTimer);
        switchTimer = window.setTimeout(() => activate(category), SWITCH_DELAY);
      });

      category.addEventListener('pointerleave', () => {
        window.clearTimeout(switchTimer);
      });

      category.addEventListener('focusin', () => activate(category));
    });

    menu.addEventListener('pointerleave', () => window.clearTimeout(switchTimer));

    menu.addEventListener('pointerenter', () => window.clearTimeout(switchTimer));
  };

  const initialiseAll = (root = document) => {
    root.querySelectorAll('.spark-mega').forEach(initialiseMenu);
    root.querySelectorAll('.spark-mobile-menu').forEach((mobileMenu) => {
      if (mobileMenu.dataset.sparkAccordionReady === 'true') return;
      mobileMenu.dataset.sparkAccordionReady = 'true';
      mobileMenu.querySelectorAll('.spark-mobile-menu__group').forEach((group) => {
        group.addEventListener('toggle', () => {
          if (!group.open) return;
          mobileMenu.querySelectorAll('.spark-mobile-menu__group[open]').forEach((otherGroup) => {
            if (otherGroup !== group) otherGroup.open = false;
          });
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll());
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
